import React, { useContext, useEffect, useState } from "react";

import { PopUpContext } from "../../contexts/popUpContext";
import { YearContext } from "../../contexts/yearContext";

import lbl from "../../data/Labels.json";
import db from "../../services/query";

import PopUpList from "../common/PopUpList";

const EntryYearPopUp = () => {
  const { togglePopUp } = useContext(PopUpContext);
  const { setEntryYear, entryYear } = useContext(YearContext);

  const [entryYears, getEntryYears] = useState([]);
  const [eValue, setEValue] = useState(entryYear);
  const [items, setItems] = useState([]);

  useEffect(async () => {
    const ac = new AbortController();
    await db.getAll(`dropdowns/entryyears`).then(({ data: { data } }) => {
      const mCurrentEntryYear = data.filter(
        (e) => parseInt(e.id) === parseInt(eValue)
      )[0];

      console.log({
        mCurrentEntryYear,
        eValue,
      });

      setItems({
        mCurrentEntryYear,
        miladi: [
          { title: "تاریخ شروع", value: mCurrentEntryYear?.start_date },
          { title: "تاریخ ختم", value: mCurrentEntryYear?.end_date },
        ],
        shamsi: [
          {
            title: "تاریخ شروع",
            value: mCurrentEntryYear?.persian_start_date,
          },
          {
            title: "تاریخ ختم",
            value: mCurrentEntryYear?.persian_end_date,
          },
        ],
      });

      getEntryYears(data);
    });
    return () => ac.abort();
  }, [eValue]);

  const handleSelect = (e) => {
    setEValue(e.target.value);
  };

  const handleEntryId = () => {
    setEntryYear(eValue);
    togglePopUp();
  };

  return (
    <div className="pop-up-container">
      <div className="pop-up-wrapper">
        <div className="pop-up-head">
          <p>{lbl.SelectSemester}</p>
        </div>
        <div className="pop-up-body flex">
          <div className="pop-up-select">
            <select onChange={handleSelect}>
              <option value="" hidden>
                {items?.mCurrentEntryYear?.name}
              </option>
              {entryYears.map((e, i) => (
                <option key={i} value={e.id}>
                  {e.name}
                </option>
              ))}
            </select>
          </div>
          <div className="pop-up-list-card">
            <p className="main-title">{lbl.Shamsi}</p>
            <PopUpList items={items?.shamsi} />
          </div>
          <div className="pop-up-list-card">
            <p className="main-title">{lbl.Miladi}</p>
            <PopUpList items={items?.miladi} />
          </div>
        </div>
        <div className="pop-up-buttons form-buttons">
          <button onClick={handleEntryId}>{lbl.Select}</button>
          <button onClick={togglePopUp}>{lbl.Cancel}</button>
        </div>
      </div>
    </div>
  );
};

export default EntryYearPopUp;
